import { gql } from '@apollo/client';
import { USER_FIELDS } from '../fragments/user.js';

export const USER_COMPLETED_FIRST_LOGIN = gql`
  mutation userCompletedFirstLogin($userId: String!) {
    userCompletedFirstLogin(userId: $userId) {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

export const RSVP = gql`
  mutation rsvp($rsvp: RSVPAnswerInput!) {
    rsvp(rsvp: $rsvp) {
      __typename
      ... on NewsFeedEventItem {
        id
        userRSVP
      }
      ... on NewsFeedSportItem {
        id
        userRSVP
      }
    }
  }
`;

export const ANSWER_POLL = gql`
  mutation answerPoll($pollId: String!, $answerIndex: Int!) {
    answerPoll(pollId: $pollId, answerIndex: $answerIndex) {
      answer
      value
    }
  }
`;

export const UPDATE_POST_LIKES = gql`
  mutation updatePostLikes($itemId: String, $likes: String) {
    updatePostLikes(itemId: $itemId, likes: $likes)
  }
`;

export const CREATE_UPDATE_COMMENT = gql`
  mutation createUpdateComment($commentId: String, $comment: CommentInput!) {
    createUpdateComment(commentId: $commentId, comment: $comment) {
      id
      body
      userName
      createdAt
      postId
      userProfileImg
    }
  }
`;

export const SEND_MESSAGE = gql`
  mutation sendMessage(
    $chatId: String!
    $messageType: MessageType!
    $content: String
    $imageData: String
  ) {
    sendMessage(
      chatId: $chatId
      messageType: $messageType
      content: $content
      imageData: $imageData
    ) {
      id
      content
      messageType
      createdAt
      author {
        id
        name
        profilePictureUrl
      }
    }
  }
`;

export const NOTIFY_CHAT_READ_STATUS = gql`
  mutation notifyChatReadStatus($chatId: String!, $messageId: String!) {
    notifyChatReadStatus(chatId: $chatId, messageId: $messageId) {
      unreadChatMessagesCount
      chat {
        id
        unreadMessagesCount
      }
    }
  }
`;

export const CONNECT = gql`
  mutation connect($userId: String!) {
    connect(userId: $userId) {
      id
      friendRequestStatus
    }
  }
`;

export const RESPOND_CONNECTION = gql`
  mutation respond($userId: String!, $response: SocialNetworkRespond!) {
    respond(userId: $userId, response: $response) {
      classmate {
        id
        friendRequestStatus
      }
    }
  }
`;

export const REMOVE_CONNECTION = gql`
  mutation removeConnection($userId: String!) {
    removeConnection(userId: $userId) {
      id
      friendRequestStatus
    }
  }
`;

export const SET_NOTIFICATIONS_READ_STATE = gql`
  mutation setNotificationsReadState($notificationId: String!) {
    setNotificationsReadState(notificationId: $notificationId)
  }
`;

export const SET_USER_FCM_TOKEN = gql`
  mutation setUserFcmToken($fcmToken: String!) {
    setUserFcmToken(fcmToken: $fcmToken)
  }
`;

export const UPDATE_PRIVACY = gql`
  mutation updatePrivacy($config: PrivacyConfigInput) {
    updatePrivacy(config: $config) {
      displayPicture
      directoryInfo
      msgEmail
      push
      facebook
      instagram
      linkedin
      twitter
      snapchat
      major
      classYear
    }
  }
`;

export const UPDATE_PROFILE_PICTURE = gql`
  mutation updateProfilePicture($imageId: String) {
    updateProfilePicture(imageId: $imageId)
  }
`;

export const ADD_PHOTO = gql`
  mutation addPhoto($photoId: String!, $label: String) {
    addPhoto(photoId: $photoId, label: $label) {
      id
      url
      approved
      label
    }
  }
`;

export const RESET_SOCIAL_LINK = gql`
  mutation resetSocialLink($type: SocialNetwork!) {
    resetSocialLink(type: $type) {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

export const CREATE_UPDATE_NEWS = gql`
  mutation createUpdateNews($newsId: String, $news: NewsInput!) {
    createUpdateNews(newsId: $newsId, news: $news) {
      id
      title
      published
    }
  }
`;

export const CREATE_UPDATE_EVENT = gql`
  mutation createUpdateEvent($eventId: String, $event: EventInput!) {
    createUpdateEvent(eventId: $eventId, event: $event) {
      id
      title
      published
    }
  }
`;

export const CREATE_UPDATE_POLL = gql`
  mutation createUpdatePoll($pollId: String, $poll: PollInput!) {
    createUpdatePoll(pollId: $pollId, poll: $poll) {
      id
      question
      published
    }
  }
`;

export const PUBLISH_TO_FEED = gql`
  mutation publishToFeed($feedItemId: String!, $platforms: [String]) {
    publishToFeed(feedItemId: $feedItemId, platforms: $platforms)
  }
`;

export const DELETE_STUDENT = gql`
  mutation deleteStudent($studentId: String!) {
    deleteStudent(studentId: $studentId)
  }
`;

export const REMOVE_COURSE = gql`
  mutation removeCourse($courseId: String!) {
    removeCourse(courseId: $courseId)
  }
`;

export const VIDEO_VIEW = gql`
  mutation videoView($videoView: VideoViewInput!) {
    videoView(videoView: $videoView)
  }
`;

export const USER_TALKED_WITH_YOGI = gql`
  mutation userTalkedWithYogi($userId: String!) {
    userTalkedWithYogi(userId: $userId) {
      id
      talkedWithYogi
    }
  }
`;

export const CREATE_UPDATE_REMINDER = gql`
  mutation createUpdateReminder($userId: ID, $reminderId: String, $reminder: ReminderInputType) {
    createUpdateReminder(userId: $userId, reminderId: $reminderId, reminder: $reminder) {
      _id
    }
  }
`;

export const REPORT_ANALYTICS = gql`
  mutation reportAnalytics($items: [AnalyticsItem]!) {
    reportAnalytics(items: $items)
  }
`;

export const GENERATE_UPLOAD_URL = gql`
  mutation generateUploadUrl($input: GenerateUploadUrlInput!) {
    generateUploadUrl(input: $input) {
      objectPath
      signedUrl
      expiresAt
    }
  }
`;

export const GENERATE_VIEW_URL = gql`
  mutation generateViewUrl($input: GenerateViewUrlInput!) {
    generateViewUrl(input: $input) {
      signedUrl
      expiresAt
    }
  }
`;
